/* Truth Scriptures: collection filtering + sorting (Ahmed Development)
   Uses Shopify storefront filtering (filter.v.* / price) and the Section
   Rendering API to swap results without a full reload. */
(() => {
  class TsCollection extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.form = this.querySelector('[data-ts-filter-form]');
      this.sectionId = this.dataset.sectionId;
      this.addEventListener('change', (e) => this.onChange(e));
      this.addEventListener('submit', (e) => {
        e.preventDefault();
        this.apply();
      });
      this.addEventListener('click', (e) => {
        const link = e.target.closest('[data-ts-filter-link]');
        if (!link) return;
        e.preventDefault();
        this.load(new URL(link.href, window.location.origin).search.replace(/^\?/, ''));
      });
      document.addEventListener('click', (e) => {
        this.querySelectorAll('details[data-ts-dd][open]').forEach((d) => {
          if (!d.contains(e.target)) d.removeAttribute('open');
        });
      });
      this.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        const open = this.querySelector('details[data-ts-dd][open]');
        if (open) {
          open.removeAttribute('open');
          open.querySelector('summary').focus();
        }
      });
      window.addEventListener('popstate', () => this.load(window.location.search.replace(/^\?/, ''), false));
    }

    onChange(e) {
      const input = e.target;
      if (!input.closest('[data-ts-desktop-filters], [data-ts-mobile-filters], [data-ts-sort]') && !input.matches('[data-ts-sort]')) return;
      const key = input.dataset.tsSync;
      if (key) {
        this.querySelectorAll(`[data-ts-sync="${CSS.escape(key)}"]`).forEach((twin) => {
          if (twin === input) return;
          if (input.type === 'checkbox') twin.checked = input.checked;
          else twin.value = input.value;
        });
      }
      clearTimeout(this._t);
      this._t = setTimeout(() => this.apply(), input.type === 'number' ? 600 : 50);
    }

    params() {
      const p = new URLSearchParams();
      this.querySelectorAll('[data-ts-desktop-filters] input').forEach((el) => {
        if (el.type === 'checkbox' && !el.checked) return;
        if (el.type === 'number' && el.value === '') return;
        p.append(el.name, el.value);
      });
      const sort = this.querySelector('[data-ts-sort]');
      if (sort) p.set('sort_by', sort.value);
      return p.toString();
    }

    apply() {
      this.load(this.params());
    }

    async load(query, push = true) {
      const results = this.querySelector('[data-ts-results]');
      results.setAttribute('aria-busy', 'true');
      results.style.opacity = '0.5';
      const url = `${window.location.pathname}?${query}${query ? '&' : ''}section_id=${this.sectionId}`;
      const openIdx = [...this.querySelectorAll('details[data-ts-dd]')].findIndex((d) => d.open);
      const activeId = document.activeElement && this.contains(document.activeElement) ? document.activeElement.id : '';
      try {
        const html = await (await fetch(url)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const swap = (sel) => {
          const next = doc.querySelector(sel);
          const cur = this.querySelector(sel);
          if (next && cur) cur.replaceWith(next);
        };
        swap('[data-ts-results]');
        swap('[data-ts-count]');
        swap('[data-ts-desktop-filters]');
        swap('[data-ts-mobile-filters]');
        if (openIdx > -1) this.querySelectorAll('details[data-ts-dd]')[openIdx]?.setAttribute('open', '');
        if (activeId) document.getElementById(activeId)?.focus({ preventScroll: true });
        if (push) window.history.pushState({}, '', `${window.location.pathname}${query ? `?${query}` : ''}`);
        window.tsInitReveal?.(this);
        window.tsInitAccordions?.(this);
      } catch (err) {
        window.location.search = query;
      } finally {
        const r = this.querySelector('[data-ts-results]');
        r.removeAttribute('aria-busy');
        r.style.opacity = '';
      }
    }
  }
  if (!customElements.get('ts-collection')) customElements.define('ts-collection', TsCollection);
})();
